/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import useDebounce from './useDebounce';

type Options<T> = {
  handleState?: (state: T) => any;
  delay?: number;
};

type UseStateDebounceReturn<T> = [T | undefined, (state: T) => void];

function useStateDebounce<T = any>(
  defaultValue?: T,
  options?: Options<T>,
): UseStateDebounceReturn<T> {
  const [defaultState, setDefaultState] = useState<T | undefined>(defaultValue);
  const state = useDebounce(defaultState, options?.delay);

  function handleState(stateDebounce: T) {
    if (options?.handleState) {
      setDefaultState(options.handleState(stateDebounce));
    } else {
      setDefaultState(stateDebounce);
    }
  }

  return [state, handleState];
}

export default useStateDebounce;
